/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import config from 'config';
import FetchJson from '$util/fetchJson';
import PostcodeAutocomplete from '$components/basic/PostcodeAutocomplete';
import NoCoverageModalContent from '$components/NoCoverageModalContent';
import CoveredModalContent from './CoveredModalContent';
import { Button } from '@/components/atoms/Button';
import { CardStyled, ModalStyled } from './styled';

const validPostcode = (postcode) => {
  postcode = postcode.replace(/\s/g, '');
  const regex =
    // eslint-disable-next-line max-len
    /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/i;
  return regex.test(postcode);
};

const isHidden = (el) => {
  const style = window.getComputedStyle(el);
  return style && style.display === 'none';
};

export default class PcLookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postcode: '',
      postcodeError: false,
      showModal: false,
      coverage: null,
    };
    this.postcodeRef = React.createRef();
  }

  hideModal = () => {
    this.setState({ showModal: false });
  };

  handleSubmit = (ev) => {
    const postcodeElem = this.postcodeRef.current;
    if (postcodeElem && !isHidden(postcodeElem)) {
      if (!this.state.postcode || !validPostcode(this.state.postcode)) {
        this.setState({ postcodeError: true });
        return ev.preventDefault();
      }

      new FetchJson({
        headers: {
          'X-Api-Key': config.get('public.fixter_api.gateway_key'),
          'Content-Type': 'application/json',
        },
      })
        .get(`${config.get('public.fixter_api.url')}/timetable?postcode=${this.state.postcode}`)
        .then((res) => {
          const dates = get(res, 'data.dates', []);
          if (dates.length) {
            this.setState({ coverage: true });
          } else {
            this.setState({ coverage: false });
          }
          this.setState({ showModal: true });
        })
        .catch((err) => {
          this.setState({
            coverage: false,
            showModal: true,
          });
          return err;
        });

      return ev.preventDefault();
    }

    return true;
  };

  render() {
    const { layout, className, pageType, uniqId, ...props } = this.props;

    return (
      <>
        <ModalStyled visible={this.state.showModal} footer={null} onCancel={() => this.hideModal()}>
          <CoveredModalContent className={classNames(`${this.state.coverage ? '-covered' : 'hidden'}`)} />
          <NoCoverageModalContent
            className={`-no-coverage ${!this.state.coverage ? '' : 'hidden'}`}
            hide={this.hideModal}
          />
        </ModalStyled>

        <CardStyled className={classNames('vrm-lookup', className)} {...props}>
          <form onSubmit={this.handleSubmit}>
            <div className="heading">Do we cover your area?</div>
            <div className="top-section">
              <div className="postcode postcode_input" ref={this.postcodeRef}>
                <span className="input-helper">Your postcode</span>
                <PostcodeAutocomplete
                  uniqId={`${uniqId}2`}
                  postcodeError={this.state.postcodeError}
                  onChange={(ev) => this.setState({ postcode: ev })}
                  placeholder="e.g EC1V 4PW"
                />

                {this.state.postcodeError && (
                  <div className="error-input-message">Enter a correct postcode</div>
                )}
              </div>
              <div className="search-btn-container">
                <Button type="submit" designType="primary" size="M" iconId="general/search-sm">
                  Search
                </Button>
              </div>
            </div>
          </form>
        </CardStyled>
      </>
    );
  }
}

PcLookup.propTypes = {
  pageType: PropTypes.array,
  className: PropTypes.string,
  layout: PropTypes.oneOf(['vertical', 'horizontal']),
  uniqId: PropTypes.string,
};

PcLookup.defaultProps = {
  pageType: [],
  className: '',
  layout: 'vertical',
  uniqId: '',
};
